import { CoordinatesPutInterface, CoordinatesInterface } from './types';

export class CoordinatesPutRequest implements CoordinatesPutInterface {
  private payload: CoordinatesInterface = {
    latitude: 0.0,
    longitude: 0.0,
  };

  public put(coordinates: CoordinatesInterface): void {
    this.payload = { ...coordinates };
    this.request();
  }

  private request() {
    fetch('/api/geo-code', {
      method: 'PUT',
      body: JSON.stringify(this.payload),
    }).catch((error) => console.warn(error));
  }
}
